(function () {
  function init() {
    var triggers = document.querySelectorAll('.js-shop-filter-trigger');

    // phones: start with every group collapsed so the first product is not a
    // full screen down; desktop keeps the server-rendered open state
    if (window.innerWidth < 1180) {
      triggers.forEach(function (t) { t.classList.remove('is-open'); });
    }

    triggers.forEach(function (trigger) {
      var content = trigger.nextElementSibling;
      if (!content) return;

      var open = trigger.classList.contains('is-open');
      content.style.height = open ? content.scrollHeight + 'px' : 0;

      trigger.addEventListener('click', function () {
        var isOpen = trigger.classList.toggle('is-open');
        content.style.height = isOpen ? content.scrollHeight + 'px' : 0;
      });
    });

    window.addEventListener('resize', function () {
      triggers.forEach(function (trigger) {
        if (!trigger.classList.contains('is-open')) return;
        var content = trigger.nextElementSibling;
        if (content) content.style.height = content.scrollHeight + 'px';
      });
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
